<template>
  <div class="search_div">
    <div class="login" v-if="!$store.state.login.finishStatus">
      <router-link to="/login">{{$t('lang.ljzc')}}</router-link>
    </div>
    <div class="hot">
      <div class="hot_title">
        {{$t('lang.djdzk')}}
        <img src="../../assets/images/hot.png" alt="" style="width:18px;vertical-align:middle;margin-top:-2px;">
      </div>
      <div class="hot_content">
        <div class="items">
          <div class="item" v-for="(item, index) in hotList" :key="item.id" @click="getLink(item)">
            <span :class="index < 2 ? 'red' : 'orange'">{{index + 1}}</span>
            <p v-if="$i18n.locale === 'zh'">{{item.title}}</p>
            <p v-else>{{item.lang.title}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="hot" style="padding-top:10px;">
      <div class="hot_title">
        为你推荐
      </div>
      <div class="ads">
        <div class="ad" v-for="item in adList" :key="item.id">
          <a :href="item.jump_url ? item.jump_url : 'javascript:;'" :target="item.jump_url ? '_blank' : ''">
            <img :src="item.img_url" alt="" style="border-radius:7px;">
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>
@import "search.less";
</style>
<script>
import ModalApi from '../../components/ModalApi'
export default {
  mixins: [ModalApi],
  data () {
    return {
      isLoading: true,
      hotList: [],
      adList: []
    }
  },
  created () {
    this.getHotList()
    this.getAdList()
  },
  watch: {
    '$i18n.locale': {
      handler: function (newer, older) {
        this.getHotList()
      },
      deep: true // 开启深度监听
    }
  },
  methods: {
    getHotList: function () {
      let self = this
      // let lang = 'zh-cn'
      // if (self.$i18n.locale === 'zh') {
      //   lang = 'zh-cn'
      // } else {
      //   lang = 'en-us'
      // }
      self.$http.get('https://goapi.gmic.cn/api/v1/room/rand_playbacks/5').then(function (res) {
        // console.log('hot')
        // console.log(res)
        if (res.data.code === 200) {
          self.hotList = res.data.data
        }
      }).catch(function (err) {
        console.log(err)
      })
    },
    getLink: function (item) {
      let self = this
      let finishStatus = self.$store.state.login.finishStatus
      let jump = localStorage.getItem('isClickJump')
      if (!finishStatus && !jump) {
        self.$router.replace({
          path: '/login'
        })
        return
      }
      if (self.$i18n.locale === 'zh') {
        self.$router.push({
          path: '/video',
          query: {id: item.playBack.aes_id}
        })
      }
    },
    getAdList: function () {
      let self = this
      self.$http.get('https://goapi.gmic.cn/api/v1/adverts?lang=zh-cn').then(function (res) {
        // console.log(res.data.data.adverts)
        if (res.data.code === 200) {
          self.adList = res.data.data.adverts.filter(item => item.type === 1)
        }
      }).catch(function (err) {
        console.log(err)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/search/search.vue